import { render, staticRenderFns } from "./OrderAging.vue?vue&type=template&id=14fe31f9&"
import script from "./OrderAging.vue?vue&type=script&lang=js&"
export * from "./OrderAging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports